import React from 'react';
import { useNavigate } from 'react-router-dom';

function NavigationButtons({ currentPage, totalPages, handlePageChange }) {
  const navigate = useNavigate(); 

  const handlePrevious = () => {
    if (currentPage === 0) {
      navigate('/config'); 
    } else {
      handlePageChange('prev'); 
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange('next'); 
    }
  };

  return (
    <div className="navigation-buttons" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
      <button
        onClick={handlePrevious}
        style={{
          padding: '10px 15px',
          fontSize: '16px',
          backgroundColor: '#333',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        ← Previous
      </button>
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        style={{
          padding: '10px 15px',
          fontSize: '16px',
          backgroundColor: currentPage === totalPages ? '#ccc' : '#333',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
        }}
      >
        Next →
      </button>
    </div>
  );
}

export default NavigationButtons;
